import { render, staticRenderFns } from "./KrefeldPlanPage.vue?vue&type=template&id=6e928244&scoped=true&"
import script from "./KrefeldPlanPage.vue?vue&type=script&lang=js&"
export * from "./KrefeldPlanPage.vue?vue&type=script&lang=js&"
import style0 from "./KrefeldPlanPage.vue?vue&type=style&index=0&id=6e928244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e928244",
  null
  
)

export default component.exports